import { ChildCareOutlined, ErrorOutline, Person } from '@mui/icons-material'
import { TableCell, TableRow } from '@mui/material'
import { FunctionComponent, useState } from 'react'
import { RegularSlot } from '@/types/Slots'
import { Daycare } from '@/types/Daycare'
import styles from './childTableRow.module.scss'
import { ChildDaycareWithParents, ChildWithParents } from '@/types/Child'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { useTranslation } from 'react-i18next'
import ParentListDialog from './Dialog/parentListDialog'
import Desktop from '@/modules/desktopMobile/desktop'
import Checkbox from '@/components/_custom/Checkbox/Checkbox'

interface ChildTableRowProps {
    child: ChildWithParents
    regularSlots: RegularSlot[]
    daycare: Daycare
    canWriteRegular: boolean
    canReadRegular: boolean
    oneChildHaveSoftwareId: boolean
    selected: boolean
    onToggleSelect: (childId: number) => void
}

const ChildTableRow: FunctionComponent<ChildTableRowProps> = ({
    child,
    regularSlots,
    daycare,
    canWriteRegular,
    canReadRegular,
    oneChildHaveSoftwareId,
    selected,
    onToggleSelect
}: ChildTableRowProps) => {
    const { t } = useTranslation()

    const navigate: NavigateFunction = useNavigate()

    const [showParentListDialog, setShowParentListDialog] = useState(false)

    const childDaycare: ChildDaycareWithParents | undefined = child.daycares.find(
        (d: ChildDaycareWithParents): boolean => d.daycareId === Number(daycare.id)
    )

    return (
        <>
            <TableRow className={styles.Clicable} onDoubleClick={() => navigate(`?child=${child.id}`)}>
                <TableCell>
                    <div className={styles.ChildName}>
                        <Checkbox
                            checked={selected}
                            onChange={() => onToggleSelect(child.id)}
                            className={styles.Checkbox}
                        />
                        <ChildCareOutlined className={styles.Icon} onClick={() => navigate(`?child=${child.id}`)} />
                        {child.firstname}
                        {childDaycare && childDaycare.complement ? ' - ' + childDaycare.complement : ''}
                    </div>
                </TableCell>
                <Desktop>
                    {canReadRegular && (
                        <TableCell>
                            <div className={styles.ButtonContainer}>
                                <ButtonTextIcon
                                    type={regularSlots.length > 0 ? 'view' : canWriteRegular ? 'add' : 'view'}
                                    onClick={() => navigate(`?child=${child.id}&regular=true`)}
                                    className={regularSlots.length > 0 ? styles.ButtonRegularSlots : ''}
                                />
                            </div>
                        </TableCell>
                    )}
                    <TableCell align={'center'}>
                        <div className={styles.IconContainer}>
                            {childDaycare && childDaycare.parents.length > 0 ? (
                                <>
                                    <p>{childDaycare.parents.length}</p>
                                    <Person className={styles.Icon} onClick={() => setShowParentListDialog(true)} />
                                </>
                            ) : (
                                <p>{t('noAdults')}</p>
                            )}
                        </div>
                    </TableCell>
                    {oneChildHaveSoftwareId && (
                        <TableCell align={'center'}>
                            {childDaycare && childDaycare.softwareId ? (
                                <p> {childDaycare.softwareId} </p>
                            ) : (
                                <ErrorOutline className={styles.Icon} />
                            )}
                        </TableCell>
                    )}
                    <TableCell />
                </Desktop>
            </TableRow>
            {showParentListDialog && childDaycare && childDaycare.parents.length > 0 && (
                <ParentListDialog
                    isDialogOpen={showParentListDialog}
                    handleCloseDialog={() => setShowParentListDialog(false)}
                    parents={childDaycare ? childDaycare.parents : []}
                />
            )}
        </>
    )
}

export default ChildTableRow
